export const PAGE_WIDTH_PT = 595.5;
export const PAGE_HEIGHT_PT = 842;
export const PT_TO_PX = 96 / 72;
export const PAGE_WIDTH_PX = PAGE_WIDTH_PT * PT_TO_PX;
export const PAGE_HEIGHT_PX = PAGE_HEIGHT_PT * PT_TO_PX;
